
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */

import EventPageContent from '@/components/client/event/EventPageContent'
import ClientLayout from '@/components/client/layout/Index'
import {
  CoursesPathsDocument,
  EventDetailsOutputDocument,
} from '@/types/graphql/types'
import { initializeApollo } from 'lib/apolloClient'
import { parseInt } from 'lodash'

const EventPage = () => {

  return (
    <ClientLayout>
      <EventPageContent/>
    </ClientLayout>
  )
}

 async function _getStaticProps({ params }: any) {
  const apolloClient = initializeApollo()

  await Promise.all([
    apolloClient.query({
      query: EventDetailsOutputDocument,
      variables: {
        eventDetailsOutputId: parseInt(params.id),
      },
    }),
  ]).catch((e) => {
    return { redirect: { destination: '/500', permanent: false } }
  })

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
    },
    revalidate: 10,
  }
}
export default EventPage

export async function getStaticPaths() {
  const apolloClient = initializeApollo()

  const { data } = await apolloClient.query({
    query: CoursesPathsDocument,
  })

  const paths = data.CoursesPaths.flatMap(c => [
    {
      params: { id: c?.id?.toString() },
      locale: 'ar',
    },
    {
      params: { id: c?.id?.toString() },
      locale: 'en',
    },
  ])

  return {
    paths,
    fallback: true, // can also be true or 'blocking'
  }
}


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/event/[id]',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  